"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GolfCartReportPageActions;
(function (GolfCartReportPageActions) {
    GolfCartReportPageActions["DataLoaded"] = "DataLoaded";
})(GolfCartReportPageActions || (GolfCartReportPageActions = {}));
exports.default = GolfCartReportPageActions;
